"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUrl = void 0;
var createUrl = function (brand, model, generationName, unique_id) {
    return "brand_name=".concat(brand, "&model_name=").concat(model, "&generation_name=").concat(generationName, "&unique_id=").concat(unique_id);
};
exports.createUrl = createUrl;
